import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import { localeString } from "@faire/help-center-utils/lib/localeString";
import { getShouldUseZendeskSandbox } from "@faire/help-center-utils/serialized-data/getShouldUseZendeskSandbox";
import searchArticle, { QueryParameters as ISearchArticlesRequest } from "@faire/web-api/api/zendesk/articles/search/get";
import fetchArticles from "@faire/web-api/api/zendesk/locale/articles/articleId/get";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
export var Article = /*#__PURE__*/_createClass(function Article(data) {
  var _this = this;
  _classCallCheck(this, Article);
  this.getPreview = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var description, _this$sandboxArticleI;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          description = "";
          if (!getShouldUseZendeskSandbox()) {
            _context.next = 10;
            break;
          }
          _context.next = 4;
          return getSandboxArticleId(_this.name);
        case 4:
          _this.sandboxArticleId = _context.sent;
          _context.next = 7;
          return generateDescription((_this$sandboxArticleI = _this.sandboxArticleId) !== null && _this$sandboxArticleI !== void 0 ? _this$sandboxArticleI : "");
        case 7:
          description = _context.sent;
          _context.next = 13;
          break;
        case 10:
          _context.next = 12;
          return generateDescription(_this.id);
        case 12:
          description = _context.sent;
        case 13:
          return _context.abrupt("return", description);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  this.getLink = function () {
    if (getShouldUseZendeskSandbox()) {
      var _this$sandboxArticleI2;
      return _this.sandboxArticleId ? articlePage((_this$sandboxArticleI2 = _this.sandboxArticleId) !== null && _this$sandboxArticleI2 !== void 0 ? _this$sandboxArticleI2 : "", {
        section: _this.section
      }) : "";
    }
    return articlePage(_this.id, {
      section: _this.section
    });
  };
  /**
   * Creates a new instance of this article overwriting the section
   * @param section
   * @returns
   */
  this.atSection = function (section) {
    return new Article({
      name: _this.name,
      id: _this.id,
      section: section
    });
  };
  this.name = data.name;
  this.id = data.id;
  this.section = data.section;
});
/**
 * Returns the article ID from the sandbox Zendesk URL
 * @param productArticleId
 * @returns The sandbox article ID
 */
var getSandboxArticleId = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(productionArticleTitle) {
    var _results$;
    var _yield$searchArticle, results;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return searchArticle(ISearchArticlesRequest.build({
            query: productionArticleTitle,
            locale: localeString
          }));
        case 2:
          _yield$searchArticle = _context2.sent;
          results = _yield$searchArticle.results;
          return _context2.abrupt("return", results !== null && results !== void 0 && (_results$ = results[0]) !== null && _results$ !== void 0 && _results$.id ? "".concat(results[0].id) : "");
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getSandboxArticleId(_x) {
    return _ref2.apply(this, arguments);
  };
}();
function generateDescription(_x2) {
  return _generateDescription.apply(this, arguments);
}
function _generateDescription() {
  _generateDescription = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(articleID) {
    var _response$article$bod, _response$article, response, str, text;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return fetchArticles(localeString, articleID);
        case 3:
          response = _context3.sent;
          str = (_response$article$bod = (_response$article = response.article) === null || _response$article === void 0 ? void 0 : _response$article.body) !== null && _response$article$bod !== void 0 ? _response$article$bod : "";
          text = str.replace(/<\/?[^>]+(>|$)/g, "");
          return _context3.abrupt("return", text);
        case 9:
          _context3.prev = 9;
          _context3.t0 = _context3["catch"](0);
          return _context3.abrupt("return", "");
        case 12:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 9]]);
  }));
  return _generateDescription.apply(this, arguments);
}